import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close-grey.svg'

import useStyles from './styles'

function ButtonClose({ className, onClick }) {
  const classes = useStyles()

  return (
    <button type="button" className={classnames(classes.closeBtn, className)} onClick={onClick}>
      <CloseIcon />
    </button>
  )
}

ButtonClose.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default ButtonClose
